{
  "userSettings": "Osobné nastavenie používateľa",
  "breadcrumb": {
    "users": "Používatelia"
  },
  "notification": {
    "all": "Všetky",
    "unread": "Neprečítané",
    "forwarded": "Preposlané v rámci zástupu užívateľa <UserHighlight>{{user}}</UserHighlight>"
  },
  "common": {
    "resetColumnWidth": "Obnoviť predvolenú šírku",
    "resetColumnWidths": "Obnoviť predvolené šírky",
    "actions": {
      "saveAndProceed": "Uložiť a pokračovať",
      "proceedWithoutChanges": "Pokračovať bez uloženia",
      "continueEditing": "Pokračovať v editácii",
      "stayOnPage": "Zostať na stránke",
      "stayOnForm": "Späť k formuláru"
    },
    "dateOfActivation": "Dátum aktivácie",
    "dateOfDeactivation": "Dátum deaktivácie",
    "buttonName": "Názov tlačidla",
    "dateMask": "DD.MM.YYYY",
    "error": "Chyba",
    "errorPage": {
      "somethingWentWrong": "Oops!",
      "tryAgainLater": "Niečo sa pokazilo. Skúste stránku obnoviť, alebo sa vráťte na hlavnú stránku.",
      "reloadPage": "Obnoviť stránku",
      "goHome": "Prejsť na hlavnú stránku",
      "copyFullStackTrace": "Kopírovať kompletný stack trace",
      "copied": "Skopírované!"
    },
    "loading": "Načítam...",
    "share": "Zdieľať",
    "invalidGuid": "Neplatný GUID",
    "activate": "Aktivovať",
    "add": "Pridať",
    "addAll": "Pridať všetko",
    "addColumn": "Pridať stĺpec",
    "addModule": "Pridať modul",
    "agenda": "Agenda",
    "childModule": "Podriadený modul",
    "addRole": "Pridať rolu",
    "bulkAddRoles": "Hromadne pridať role",
    "bulkAddRolesModalTitle": "Hromadné pridanie role",
    "bulkAddRolesPreview": "Priradených {{assigned}} rolí.",
    "sortById": "Zoradiť podľa ID",
    "bulkAddUsers": "Pridať používateľom hromadne",
    "noUsersFound": "Nenašli sa žiadni používatelia",
    "addRow": "Pridať riadok",
    "transferRoles": "Preniesť role",
    "addTab": "Pridať záložku",
    "addSubTab": "Pridať záložku ako podsekciu",
    "selectParentSection": "Vyberte nadradenú sekciu",
    "noSectionsOnTab": "Na tejto záložke nie sú žiadne sekcie. Vytvorte najprv sekciu.",
    "selectTab": "Vyberte záložku",
    "selectSubTab": "Vyberte podsekciu",
    "subTab": "Podsekcia",
    "subTabDefault": "Hlavná",
    "subTabNew": "Nová podsekcia",
    "tab": "Záložka",
    "tabName": "Názov záložky",
    "subTabName": "Názov podsekcie",
    "addUser": "Pridať používateľa",
    "advanceFilter": "Pokročilé filtrovanie",
    "again": "Znovu",
    "agendaName": "Názov agendy",
    "agendaRoles": "Role agend",
    "aggregationGroups": "Agregačné skupiny",
    "and": "a",
    "archivate": "Archivovať",
    "atLeastOneRequired": "Musí byť začiarknuté aspoň jedno pole",
    "attributeName": "Názov atribútu",
    "author": "Autor",
    "back": "Späť",
    "button": "Tlačidlo",
    "byUser": "užívateľom",
    "cancel": "Zrušiť",
    "checkbox": "Zaškrtávacie políčko",
    "close": "Zatvoriť",
    "color": "Farba",
    "columns": "Stĺpce",
    "aggregation": "Agregácia",
    "grouping": "Seskupenie",
    "pinLeft": "Pripnúť vľavo",
    "pinRight": "Pripnúť vpravo",
    "comingSoon": "Pripravujeme",
    "conditions": "Podmienky",
    "massChanges": "Hromadné zmeny",
    "logs": "Logy",
    "confirm": "Potvrdiť",
    "create": "Vytvoriť",
    "copied": "Skopírované",
    "copy": "Kopírovať",
    "copyRow": "Kopírovať riadok",
    "dataModel": "Datový model",
    "printConfigurations": "Konfigurácie tlače",
    "update": "Aktualizovať",
    "invalidPhoneNumber": "Neplatné telefónne číslo",
    "isKey": "Je kľúč",
    "isRequired": "je povinné pole",
    "mustBeNumber": "musí byť číslo",
    "clear": "Vyčistiť",
    "none": "Žiadne",
    "noneMale": "Žiadni",
    "sum": "Súčet",
    "average": "Priemer",
    "minimum": "Minimum",
    "maximum": "Maximum",
    "count": "Počet",
    "no": "Nie",
    "notFilled": "Nevyplnené",
    "notSelected": "Nevybrané",
    "yes": "Áno",
    "selectAnItem": "Vyberte položku",
    "openInNewTab": "Otvoriť v novej karte",
    "versions": {
      "button": "Verzie",
      "currentVersion": "Aktuálna verzia",
      "createdBy": "Vytvoril",
      "at": "o",
      "lastUpdateBy": "Aktualizované",
      "noVersionsAvailable": "Žiadne dostupné verzie",
      "restore": "Obnoviť verziu",
      "preview": "Náhľad",
      "substitutedBy": "v režime zástupu. Zastupujúci používateľ:",
      "substitutedByShort": "zastúpený:",
      "modal": {
        "title": "Zoznam verzií",
        "currentVersion": "Aktuálna verzia id:"
      }
    },
    "user": {
      "withoutName": "Bez mena"
    },
    "date": {
      "_": "Dátum",
      "day": "Deň",
      "month": "Mesiac",
      "time": "Čas",
      "today": "Dnes",
      "year": "Rok"
    },
    "dateTimeCalendar": "Vyberte dátum a čas",
    "deactivate": "Deaktivovať",
    "deactive": {
      "message": "Potvrdením dojde k deaktivácii prístupových údajov u používateľa"
    },
    "delete": "Zmazať",
    "deleted": {
      "roles": "Role boli úspešne deaktivované"
    },
    "download": "Stiahnite si",
    "downloadAll": "Stiahnuť všetko",
    "downloadSuccess": "Súbor bol úspešne stiahnutý",
    "failedToDownload": "Nepodarilo sa stiahnuť",
    "draft": "Návrh",
    "edit": "Upraviť",
    "editable": "Upraviteľný",
    "editRow": "Upraviť riadok",
    "editValidFrom": "Editovať platnosť od",
    "editValidUntil": "Editovať platnosť do",
    "email": "Email",
    "empty": "Prázdne",
    "contactEmail": "Kontaktný email",
    "reference": "Reference",
    "export": "Export",
    "filterBy": "Filtrovanie",
    "filters": "Filtre",
    "from": "Od",
    "to": "Do",
    "files": "Súbory",
    "file": "Súbor",
    "flow": {
      "_": "Flow",
      "approval": "Flow Schvaľovanie",
      "runFunction": "Flow Spúšťanie funkcií",
      "archive": "Flow Archivácia",
      "comment": "Flow Komentovanie",
      "create": "Flow Tvorba záznamu",
      "delete": "Flow Mazanie",
      "edit": "Flow Editácia záznamu",
      "history": "Flow História",
      "read": "Flow Čítanie",
      "title": "Flow"
    },
    "flowApproval": "flow.approval",
    "flowArchive": "flow.archive",
    "flowComment": "flow.comment",
    "flowCreate": "flow.create",
    "flowDelete": "flow.delete",
    "flowHistory": "flow.history",
    "flowRead": "flow.read",
    "form": "Formulár",
    "personalSettings": "Osobné nastavenia",
    "grid": "Grid",
    "helios": {
      "_": "Helios",
      "copy": "Helios Kopírovanie",
      "copyLine": "Helios Kopírovanie v riadku",
      "create": "Helios Tvorba",
      "createLine": "Helios Tvorba v riadku",
      "delete": "Helios Mazanie",
      "edit": "Helios Editácia",
      "editLine": "Helios Editácia v riadku",
      "export": "Helios Export tabuliek",
      "title": "Helios",
      "saved": "Úspešne uložené"
    },
    "Helios": {
      "edit": "Helios editácia"
    },
    "heliosCopy": "Helios.copy",
    "heliosCopyLine": "Helios.copyLine",
    "heliosCreate": "Helios.create",
    "heliosCreateLine": "Helios.createLine",
    "heliosDelete": "Helios.delete",
    "heliosEditLine": "Helios.editLine",
    "heliosExport": "Helios.export",
    "hidden": "Skryté",
    "icon": "Ikona",
    "removeIcon": "Odstraniť ikonu",
    "individualChoice": "Jednotlivá voľba",
    "infinitive": "Neobmedzene",
    "invalidEmail": "Neplatný email",
    "invalidInput": "Neplatný vstup",
    "isUnique": "Unikátní",
    "lastModified": "Posledná úprava:",
    "maxLength": "Max. počet povolených písmen",
    "maxSize": "Súbor je väčší ako",
    "maxValue": "Hodnota musí byť menšia alebo rovná: ",
    "minValue": "Hodnota musí byť väčšia alebo rovná: ",
    "rangeValue": "Hodnota musí byť v rozsahu {{min}} až {{max}}",
    "multiSelectOption": "Možnosť multi-select",
    "name": "Meno",
    "notSave": "Neuložiť",
    "previous": "Predchádzajúci",
    "next": "Ďalší",
    "noEdits": "Žiadne zmeny na uloženie",
    "name_cs": "Názov (CZ)",
    "name_en": "Názov (EN)",
    "name_sk": "Názov (SK)",
    "label_cs": "Názov (CZ)",
    "label_en": "Názov (EN)",
    "label_sk": "Názov (SK)",
    "noCorrectPattern": "Neplatný formát",
    "noData": "Žiadne dáta",
    "noFiles": "Žiadne súbory",
    "noIcon": "Nebola nájdená žiadna ikona",
    "noRequiredField": "Toto pole nemusí byť vyplnené",
    "noSelected": "Nevybraté",
    "number": "Číslice",
    "operation": "Operácia",
    "options": "Možnosti",
    "or": "nebo",
    "organization": "Organizácie",
    "outOf": "z",
    "phoneNumber": "Telefón",
    "placeholder": {
      "columnName": "Názov stĺpca",
      "email": "Email používateľa",
      "contactEmail": "Kontaktný email používateľa",
      "reference": "Referencie",
      "icon": "Vyberte ikonu",
      "multilangName": "Názov",
      "name": "Meno používateľa",
      "name_cs": "Názov (CZ)",
      "name_en": "Názov (EN)",
      "name_sk": "Názov (SK)",
      "role": "Meno novej roly",
      "rowCount": "Počet riadkov"
    },
    "preview": "Náhľad",
    "publish": "Zverejniť",
    "required": "Povinné pole",
    "selectedItems": "Vybrané položky",
    "removeItem": "Odstrániť {{item}}",
    "richText": {
      "sizeSmall": "Malé",
      "sizeNormal": "Normálne",
      "sizeLarge": "Veľké",
      "sizeHuge": "Obrovské",
      "fontSansSerif": "Bezpatkové",
      "fontSerif": "Patkové",
      "fontMonospace": "Monospace",
      "tooltipVisitUrl": "Navštíviť URL:",
      "tooltipEdit": "Upraviť",
      "tooltipSave": "Uložiť",
      "tooltipRemove": "Odstrániť",
      "tooltipEnterLink": "Zadajte odkaz:",
      "promptEnterUrl": "Zadajte platnú URL: (https://www.example.com)"
    },
    "requiredWithFieldName": "Pole \"{{fieldName}}\" je povinné",
    "requiredWithFieldNameAndCount": "Pole \"{{fieldName}}\" je povinné ({{count}}x)",
    "diactricCharactersNotAllowed": "Diakritické znaky nie sú povolené",
    "role": {
      "added": "Rola bola úspešne pridaná"
    },
    "roles": {
      "_": "Role",
      "": "Editácia",
      "approval": "Schvaľovanie",
      "archive": "Archivácia",
      "comment": "Komentovanie",
      "copy": "Kopírovanie",
      "copyLine": "Kopírovanie v riadku",
      "create": "Tvorba",
      "createLine": "Tvorba v riadku",
      "delete": "Mazanie",
      "edit": "Editácia",
      "editLine": "Editácia riadku",
      "export": "Export",
      "history": "História",
      "read": "Čítanie"
    },
    "rowControls": "Ovládacie prvky riadku",
    "rowCount": "Počet riadkov",
    "refresh": "Obnoviť",
    "refreshCooldown": "Obnoviť o {{seconds}} s",
    "save": "Uložiť",
    "saveDraft": "Uložiť návrh",
    "saveAndClose": "Uložiť a Zavrieť",
    "search": {
      "_": "Hľadať",
      "icons": "vyhľadávať v ikonách",
      "modules": "Hľadať v moduloch",
      "modulesAndAgendas": "Hľadať v moduloch a agendách",
      "notificationTemplates": "Hľadať v šablónach oznámení",
      "records": "Hľadať v záznamoch",
      "roles": "Hľadať v rolách",
      "tables": "Hľadať v tabuľkách",
      "users": "Hľadať v používateľoch",
      "dataSources": "Hľadať zdroje",
      "substitutions": "Hľadať v zástupoch"
    },
    "selectedUsers": "Vybraní používatelia",
    "selectedRoles": "Vybrané role",
    "noRolesFound": "Žiadne role nenájdené",
    "section": "Sekcia",
    "parentSectionName": "Názov nadradenej sekcie",
    "sectionName": "Názov sekcie",
    "collapsed": "Zobraziť sekciu ako zbalenú",
    "description": "Popis",
    "select": "Vybrať",
    "selected": "Vybrané",
    "selectValue": "Vyberte hodnotu",
    "settings": "Nastavenia",
    "settingsAdmin": "Administrátor nastavení",
    "showAll": "zobraziť všetky",
    "loadMore": "Zobraziť viac",
    "showingRecords": "Zobrazených {{shown}} z {{total}} záznamov",
    "state": "Stav",
    "stateLabels": {
      "draft": "Návrh",
      "active": "Aktívny",
      "disable": "Vypnuté"
    },
    "source": "Zdroj",
    "sourceType": {
      "createdDate": "Vytvorené",
      "dateNow": "Dnešný deň",
      "emptyValue": "Prázdna hodnota",
      "formItem": "Položka formulára",
      "realUserId": "Skutočné Id užívateľa",
      "updatedDate": "Aktualizované",
      "userEmail": "Email užívateľa",
      "userId": "Id užívateľa",
      "userRole": "Úloha užívateľa",
      "userContactEmail": "Kontaktný email užívateľa",
      "userReference": "Referencie užívateľa"
    },
    "specialChar": "Referencie",
    "success": "Úspešne odoslané",
    "tableControls": "Ovládacie prvky tabuľky",
    "tellNumber": "Telefónne číslo",
    "emailWithUserId": "E-mail s User ID",
    "templatesAdmin": "Administrátor šablón",
    "text": "Text",
    "textField": "Textové pole",
    "title": "Nadpis",
    "type": "Typ",
    "unique": "Unikátny",
    "isActionInput": "Atribúty editovateľné v detaile",
    "isParentInput": "Rodičovský vstup",
    "updateDateOfActivation": "Aktualizovať dátum aktivácie",
    "updateDateOfDeactivation": "Aktualizovať dátum deaktivácie",
    "upload": "Nahrať",
    "uploadFileSuccess": "Súbor bol úspešne nahraný",
    "uploadFileError": "Chyba pri nahrávaní súboru",
    "uploadFromGoogle": "Pripojiť z Google Drive",
    "usable": "Použiteľné",
    "userDefinedField": "Užívateľsky definované pole",
    "userDetails": "Detaily používateľa",
    "userInfo": "Informácie o používateľovi",
    "usernamePlaceholder": "Používateľ",
    "usersAdmin": "Administrátor používateľov",
    "userSettings": "Užívateľské nastavenia",
    "validFrom": "Platnosť od",
    "validUntil": "Platnosť do",
    "value": "Hodnota",
    "view": "Zobraziť",
    "viewRoles": "Role pohľadov",
    "visible": "Viditeľné",
    "visibleinmenu": "Viditeľné",
    "warning": "Pozor",
    "write": "Napíšte",
    "widget": "Widget",
    "helper": {
      "conditions": "Podmienky"
    },
    "maxLengthLimited": "Max. počet povolených písmen (nie viac ako 1000)",
    "maxLengthError": "Pole môže obsahovať maximálne {{count}} znakov.",
    "visibilityName": "Názov viditeľnosti",
    "startValue": "Počiatočná hodnota",
    "defaultValue": "Predvolená hodnota",
    "defaultValueSource": "Predvolená vybraná hodnota",
    "offsetDays": "Posun dní",
    "offsetDaysHelp": "Počet dní pripočítaných k aktuálnemu dátumu (záporné = minulosť)",
    "favorite": "Pridať do obľúbených",
    "unfavorite": "Odstrániť z obľúbených"
  },
  "filters": {
    "title": "Filtry",
    "savedFilters": "Uložené filtry",
    "selectSavedFilter": "Vyberte uložený filter",
    "reset": "Resetovať",
    "apply": "Potvrdiť",
    "editFilter": {
      "title": "Upraviť filter"
    },
    "created": "Filter bol úspešne vytvorený",
    "updated": "Filter bol úspešne upravený",
    "deleted": "Filter bol úspešne zmazaný",
    "nestedLevelWarning": "Pre filtrovanie 2. úrovne vnorovania (položiek položiek) musí byť zapnuté zobrazenie stĺpcov vo výsledkoch filtrovania",
    "saveFilter": {
      "title": "Uložiť filter",
      "name": "Názov filteru",
      "placeholder": "Zadejte názov filtru",
      "save": "Uložiť",
      "default": "Predvolený",
      "global": "Dostupný pre všetkých"
    }
  },
  "form": {
    "section": {
      "error": {
        "duplicate": "Názov bunky musí byť jedinečný",
        "remove_col": "Nie je možné odstrániť stĺpec, pretože obsahuje položky",
        "remove_row": "Nie je možné odstrániť riadok, pretože obsahuje položky"
      },
      "grid": {
        "delete_row": "Odstraňovanie riadku {{index}}",
        "delete_col": "Odstraňovanie stĺpca {{index}}",
        "rows": "Riadky",
        "columns": "Stĺpce",
        "validation": {
          "valid": "Pozícia je platná",
          "out_of_bounds": "Mimo mriežky",
          "collision_multiple": "Kolízia s viacerými položkami",
          "collision_single": "Prekrýva položku",
          "size_mismatch": "Rozdielna veľkosť položiek"
        }
      }
    }
  },
  "languages": {
    "cs": "Česky",
    "en": "Anglicky",
    "sk": "Slovensky",
    "translateToLangauge": {
      "cs": "Česky",
      "en": "Anglicky",
      "sk": "Slovensky"
    }
  },
  "login": {
    "error": {
      "unknown": "Došlo k chybe. Prosím, skúste to znova neskôr."
    },
    "login": {
      "google": "Prihlásiť sa pomocou Google",
      "microsoft": "Prihlásiť sa pomocou Microsoft",
      "subtitle": {
        "google": "Prihláste sa k svojmu účtu Google alebo zadajte údaje",
        "microsoft": "Prihláste sa k svojmu účtu Microsoft alebo zadajte údaje"
      }
    },
    "pin": {
      "forgotPin": "Zabudli ste PIN?",
      "login": "Prihlásiť sa",
      "subtitle": "Pre prihlásenie k svojmu účtu zadajte PIN"
    },
    "stayLoggedIn": "Ostať prihlásený",
    "title": "Prihlásenie"
  },
  "modal": {
    "sourceSelect": {
      "title": "Vyberte zdroj"
    }
  },
  "modulesAndAgendas": {
    "moduleSelect": {
      "required": "Vyberte modul"
    }
  },
  "sidebar": {
    "admin": {
      "core": {
        "_": "Core",
        "appSettings": "Nastavenia aplikácie",
        "assistants": "Asistenti",
        "modules": "Moduly",
        "roles": "Role",
        "substitutability": {
          "_": "Zastupiteľnosť",
          "detail": "Detail zástupu"
        },
        "users": "Používatelia"
      },
      "flow": {
        "_": "Flow",
        "agendaImports": {
          "_": "Import agiend"
        },
        "modules&agendas": {
          "_": "Moduly a Agendy",
          "create": "Vytvoriť modul",
          "edit": "Upraviť agendu",
          "view": " Pohľad"
        },
        "notification": "Notifikačné šablóny",
        "restApiConnections": "Rest api pripojenia",
        "tables": {
          "_": "Tabuľky",
          "view": "Pohľad"
        }
      },
      "helios": {
        "_": "Helios",
        "dataSource": "Dátové zdroje",
        "functions": "Funkcie",
        "tables": "Tabuľky",
        "templates": "Šablóny",
        "notification": "Notifikačné šablóny",
        "templatesImport": "Import šablóny"
      }
    },
    "adminZone": "Administrátorská zóna",
    "core": {
      "appSettings": "Nastavenia aplikácie",
      "assistants": "Asistenti",
      "modules": "Moduly",
      "roles": "Role",
      "users": "Používatelia"
    },
    "flow": {
      "agendas": "Agendy",
      "modulesAndAgendas": {
        "_": "Moduly a Agendy",
        "create": "Vytvoriť modul",
        "edit": "Upraviť modul",
        "view": " Pohľad"
      },
      "notification": "Notifikačné šablóny",
      "tables": "Tabuľky"
    },
    "helios": {
      "dataSource": "Dátové zdroje",
      "functions": "Funkcie",
      "tables": "Tabuľky",
      "templates": "Šablóny"
    },
    "logout": "Odhlásiť sa",
    "feedback": "Poslať spätnú väzbu",
    "profile": "Profil",
    "userSettings": "Osobné nastavenia",
    "substitutes": "Zástup",
    "substitutesTabs": {
      "planned": "Plánované zastupovanie",
      "substituteUser": "Používateľ zastupujúci",
      "detail": "Detail zastúpenia",
      "columns": {
        "substitutionType": "Typ zástupu",
        "dateFrom": "Dátum od",
        "dateTo": "Dátum do",
        "absentUser": "Zastupovaný používateľ",
        "absentUserEmail": "Email zastupovaného",
        "substituteUser": "Zastupujúci používateľ",
        "substituteUserEmail": "Email zastupujúceho",
        "roles": "Roly"
      }
    },
    "user": {
      "action": "Nevybavené úlohy",
      "applicationsAndModules": "Aplikácia / Moduly",
      "contacts": "Rozdeľovník",
      "info": "Neprečítané informácie",
      "overview": "Prehľad",
      "yourModules": "Vaše moduly"
    },
    "userZone": "Užívateľská zóna"
  },
  "table": {
    "buttons": {
      "add": "Pridať",
      "exportCsv": "Exportovať do CSV",
      "delete": "Zmazať",
      "edit": "Upraviť",
      "importFunctions": "Importovať funkciu"
    },
    "common": {
      "selectDateRange": "Platnosť"
    },
    "footer": {
      "rowsPerPage": "Riadkov na stranu"
    },
    "header": {
      "classId": "ID triedy",
      "created": "Vytvorené",
      "createdBy": "Vytvoril",
      "creator": "Vytvoril",
      "dateOfActivation": "Dátum aktivácie",
      "dateOfChange": "Dátum zmeny",
      "dateOfDeactivation": "Dátum deaktivácie",
      "dateOfExport": "Dátum exportu",
      "dateOfImport": "Dátum importu",
      "email": "Email",
      "contactEmail": "Kontaktný email",
      "exists": "Existuje",
      "flow": "Flow",
      "folderId": "ID zložky",
      "fullName": "Meno",
      "helios": "Helios",
      "icon": "Ikona",
      "id": "ID",
      "lastChangedDate": "Dátum poslednej zmeny",
      "moduleName": "Názov modulu",
      "module": "Modul",
      "name": "Názov",
      "name_Cz": "Názov (CZ)",
      "name_En": "Názov (EN)",
      "name_Sk": "Názov (SK)",
      "numberOfColumns": "Počet stĺpcov",
      "numberOfRows": "Počet riadkov",
      "role": "Rola",
      "permissions": "Oprávnenia",
      "reference": "Referencie",
      "roleName": "Názov role",
      "roles": "Role",
      "assignedRoles": "Priradené role",
      "assistants": "Asistenti",
      "detail": "Detail",
      "rowCount": "Počet riadkov",
      "schema": "Schema",
      "status": "Stav",
      "tags": "Štítky",
      "userName": "Meno používateľa",
      "validFrom": "Platné od",
      "validity": "Platnosť",
      "validTo": "Platné do",
      "value": "Hodnota",
      "views": "Pohľady",
      "visibility": "Viditeľnosť",
      "tableName": "Názov tabuľky",
      "userSettings": "Používateľské nastavenia",
      "dataSources": "Dátové zdroje",
      "agendaName": "Názov agendy",
      "updated": "Aktualizované",
      "authorOfCurrentVersion": "Autor aktuálnej verzie",
      "dataSource": "Dátový zdroj",
      "type": "Typ",
      "loginUrl": "URL prihlásenia",
      "domainUrl": "URL domény",
      "googleUrl": "URL Google",
      "profile": "Profil",
      "timeZoneId": "Časové pásmo",
      "column": "Stĺpec",
      "database": "Databáza",
      "item": "Položka",
      "parentColumn": "Rodičovský stĺpec",
      "general": "Všeobecné",
      "wslUrlBasic": "Základná URL",
      "wsUrlDomain": "Doménová URL",
      "wsUrlGoogle": "Google URL",
      "wsProfile": "Profil",
      "valid": "Platné",
      "maxConcurrentConnections": "Maximálny počet súčasných pripojení",
      "isCommon": "Je obecná",
      "datasourceName": "Dátový zdroj",
      "isRecordFunction": "Položková funkcia",
      "heliosFunctionId": "Helios ID",
      "number": "ID",
      "alias": "Alias",
      "description": "Popis",
      "label": "Názov",
      "vsgAssistantId": "ID asistenta",
      "subject": "Predmet",
      "baseUrl": "Base URL",
      "authType": "Typ autentifikácie",
      "isConnected": "Pripojené"
    },
    "status": {
      "active": "Aktívny",
      "archived": "Archivovaný",
      "design": "Dizajn",
      "draft": "Návrh",
      "inactive": "Neaktívny",
      "invited": "Pozvaný",
      "inprocess": "prebiehajúce",
      "imported": "importované",
      "new": "Nový",
      "pending": "Čakajúci",
      "online": "Online",
      "offline": "Offline",
      "unknown": "Neznámy",
      "success": "Úspech",
      "failed": "Zlyhalo",
      "created": "Vytvorené",
      "updated": "Aktualizované"
    }
  },
  "toast": {
    "version": {
      "restored": "Verzia bola úspešne obnovená",
      "error": "Chyba pri obnovení verzie"
    },
    "activated": {
      "users": "Používateľ bol úspešne aktivovaný",
      "usersFromRole": "Používatelia boli úspešne aktivovaní"
    },
    "added": {
      "record": "Prehlad bol úspešne pridaný",
      "rolesToUser": "Role boli úspešne pridané",
      "rolesToUsersBulk": "Úspešne priradených {{assigned}} rolí, {{users}} používateľom. Preskočených {{skipped}} duplicit.",
      "rolesToUsersBulk_all": "Priradených {{assigned}} rolí, {{users}} používateľom",
      "rolesToUsersBulk_partial": "Priradených {{assigned}} rolí, {{users}} používateľom. Preskočených {{skipped}} duplikátov",
      "rolesToUsersBulk_allSkipped": "Všetky vybrané role mali používatelia už priradené.",
      "rolesToTemplatesBulk": "Priradených {{assigned}} rolí, {{templates}} šablónam.",
      "user": "Používateľ bol úspešne pridaný",
      "usersToRole": "Používatelia boli úspešne pridaní"
    },
    "calculated": {
      "error": "Chyba pri prepočítavaní záznamu"
    },
    "dashboard": {
      "created": "Dashboard bol úspešne vytvorený",
      "deleted": "Dashboard bol úspešne zmazaný",
      "updated": "Dashboard bol úspešne aktualizovaný",
      "createFailed": "Chyba pri vytváraní dashboardu",
      "deleteItemFailed": "Nie je možné odstrániť položku: Neplatné ID"
    },
    "deactivated": {
      "users": "Používateľ bol úspešne deaktivovaný",
      "usersFromRole": "Používatelia boli úspešne deaktivovaní"
    },
    "deleted": {
      "import": "Importy boli úspešne odobrané",
      "rolesFromUser": "Role boli úspešne odobrané",
      "usersFromRole": "Používatelia boli úspešne odobraní"
    },
    "module": {
      "created": "Modul bol úspešne vytvorený",
      "deleted": "Moduly boli úspešne zmazané",
      "updated": "Modul bol úspešne upravený",
      "createFailed": "Chyba pri vytváraní modulu",
      "noData": "Modul neobsahuje žiadne dáta",
      "missingId": "Modulu chýba ID",
      "deleteFailed": "Chyba pri mazaní modulu",
      "updateFailed": "Chyba pri úprave modulu"
    },
    "assistant": {
      "created": "Asistent bol úspešne vytvorený",
      "updated": "Asistent bol úspešne upravený",
      "deleted": "Asistent bol úspešne zmazaný",
      "createFailed": "Chyba pri vytváraní asistenta",
      "updateFailed": "Chyba pri úprave asistenta",
      "deleteFailed": "Chyba pri mazaní asistenta"
    },
    "modules": {
      "orderUpdated": "Poradie modulov bolo úspešne upravené"
    },
    "saved": {
      "user": "Používateľ bol úspešne uložený"
    },
    "updated": {
      "record": "Prehlad bol úspešne upravený",
      "role": "Rola bola úspešne upravená",
      "rolesToUser": "Role boli úspešne aktualizované",
      "widget": "Widget bol úspešne upravený",
      "validFrom": "Platnosť bola úspešne upravená",
      "validUntil": "Platnosť bola úspešne upravená",
      "error": "Pri ukladaní došlo k chybám"
    },
    "archived": {
      "agendas": "Agendy boli úspešne archivované"
    },
    "record": {
      "shared": "Záznam bol úspešne zdieľaný",
      "error": "Niečo sa pokazilo"
    },
    "transfered": {
      "roles": "Role boli úspešne prenesené"
    },
    "action": {
      "completed": "Akcia bola úspešne dokončená",
      "loadFailed": "Akciu '{{actionType}}' sa nepodarilo načítať kvôli poškodeným dátam"
    },
    "error": {
      "action": "Akcia zlyhala",
      "save": "Pri ukladaní nastala chyba",
      "invalidBreadcrumbStructure": "Neplatná štruktúra navigácie"
    }
  },
  "search": {
    "_": "Hľadať",
    "noResults": "Žiadne výsledky",
    "failed": "Nepodarilo sa načítať výsledky"
  },
  "view": {
    "added": "Pohľad bol úspešne pridaný",
    "successfully": {
      "deleted": "Pohľad bol úspešne zmazaný"
    },
    "table": {
      "add": "Pridať pohľad",
      "addColumn": "Pridať stĺpec",
      "comparisonType": "Vyberte typ porovnania",
      "Contains": "Obsahuje",
      "edit": "Upraviť pohľad",
      "HasCountOf": "Má počet",
      "HasNotCountOf": "Nemá počet",
      "IsBigger": "Je väčšie",
      "IsBiggerBy": "≧ zdroj +/- hodnota",
      "IsEmpty": "Je prázdne",
      "IsEqual": "Je rovnaké",
      "IsNotEmpty": "Nie je prázdne",
      "IsNotEqual": "Nie je rovnaké",
      "IsSmaller": "Je menšie",
      "IsSmallerBy": "≦ zdroj +/- hodnota",
      "name": "Názov pohľadu",
      "None": "Žiadne",
      "noneColumnError": "Tabuľka musí obsahovať aspoň jeden stĺpec",
      "NotContains": "Neobsahuje",
      "oneEnabledColumnError": "Tabuľka musí mať aspoň jeden povolený stĺpec",
      "variable": "Variabilné",
      "filtering": "Filtrovacie",
      "editable": "Interaktívny",
      "IsPressed": "Je stlačené",
      "IsChecked": "Je zaškrtnuté",
      "IsUnchecked": "Je nezaškrtnuté"
    }
  },
  "substitution": {
    "titleNew": "Nový zástup",
    "titleEdit": "Upraviť zástup",
    "allUsersTableTitle": "Zástupy všetkých používateľov",
    "fields": {
      "substitutionType": "Typ zástupu",
      "dateFrom": "Dátum od",
      "dateTo": "Dátum do",
      "substituteUser": "Zastupujúci používateľ",
      "roles": "Roly",
      "permanentSubstitution": "Trvalý zástup",
      "allowNotificationRedirect": "Odosielať zastupujúcemu notifikácie"
    },
    "modal": {
      "delete": {
        "title": "Zmazať zástup",
        "message": "Naozaj chcete zmazať tento zástup?",
        "rows": "Naozaj chcete zmazať vybrané zástupy?"
      }
    },
    "errors": {
      "cannotDeleteActiveOrPastSubstitution": "Nie je možné zmazať aktívny alebo minulý zástup"
    },
    "selectUser": "Vyberte používateľa",
    "selectAbsentUser": "Vyberte neprítomného používateľa",
    "selectRoles": "Vyberte roly",
    "searchRoles": "Hľadať roly alebo štítky...",
    "rolesWithoutTags": "Roly bez štítkov",
    "tags": "Štítky",
    "roles": "Roly",
    "noSubstitutingUsersAvailable": "Pre vaše roly nie sú dostupní žiadni zastupujúci používatelia",
    "noRolesSelected": "Nie sú vybrané žiadne roly",
    "noUsersToSubstitute": "Nie sú dostupní žiadni používatelia na zastupovanie",
    "selectUserToSubstitute": "Vyberte používateľa na zastupovanie",
    "activateSubstitution": "Aktivovať zástup",
    "type": {
      "absence": "Neprítomnosť",
      "substitution": "Zástup"
    },
    "successfullyDeleted": "Zástup bol úspešne zmazaný"
  }
}
